export default "__VITE_ASSET__f7cc87fc__"